import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, signal } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'ol';
import { RockType } from 'src/app/bo/geology/rockType';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-rock-type-modal',
  templateUrl: './rock-type-modal.component.html',
  styleUrls: ['./rock-type-modal.component.scss'],
  standalone: false
})
export class RockTypeModalComponent implements OnInit {
  
  siteId:number;
  selectedRockType: RockType;
  showError = signal(false);
  isModif:boolean;

  constructor(
    private readonly http: HttpService,
    private readonly bsModalRef: BsModalRef,
    private readonly fonctionsService: FonctionsService,
    private readonly bsModalService: BsModalService 
    ) { }

  ngOnInit(): void {
    this.selectedRockType.siteId = this.siteId;
  }

  protected onSubmit(isDelete = false){
    if(!isDelete){
      if(!this.selectedRockType.name  ||
        !this.selectedRockType.density
        //  !this.selectedRockType.compressiveStrength||
        //  !this.selectedRockType.youngModulus||
        //  !this.selectedRockType.shearModulus||
        //  !this.selectedRockType.rqd||
        //  !this.selectedRockType.theoreticalSpeed||
        //  !this.selectedRockType.poissonRatio
         ){
        this.showError.set(true);
        setTimeout(() => {
        this.showError.set(false);
      }, 1500);
      return false;
      }
    }

    const url = "Geology/rocktype";

    let request = this.isModif ? this.http.put<RockType, any>(url, this.selectedRockType) : this.http.post<RockType, any>(url, this.selectedRockType);

    this.fonctionsService.loading_screen(true);
  
    request.subscribe({
    next: result =>{
      this.fonctionsService.launch_toast(true);
      this.fonctionsService.loading_screen(false);
      const reload = 'true';
      this.bsModalService.setDismissReason(reload);
      this.bsModalRef.hide();
    } ,
    error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
      const reload = 'false';
      this.bsModalService.setDismissReason(reload);
      this.bsModalRef.hide();
    }})
  }

  protected delete(){
    this.isModif = true;
    this.selectedRockType.siteId = 0;
    const isDelete = true;
    this.onSubmit(isDelete);
  }

  protected close() {
    this.bsModalRef.hide();
 }  


}
